import { cafeteriaBasePathMask, createPath } from 'app/pages/routePaths'


type Props = {
  id: string,
  schoolType?: string,
}

const getBaseUrl = ({ id, schoolType = 'general' }: Props) => {
  return createPath({ id, schoolType }, cafeteriaBasePathMask)
}

export default getBaseUrl
